<template>
  <div class="coupon-service">
    <common-layout>
      <div slot="header">
        <h3>创新券兑现</h3>
      </div>
      <div slot="container">
        <div class="coupon-service.header">
          <section>
            <el-button
                class="coupon-service.addBtn"
                type="success"
                @click="addEvent"
            >+ 新增
            </el-button
            >
            <el-button type="danger" @click="deleteAll">批量删除</el-button>
          </section>
          <section>
            <el-button type="primary" @click="downFn">下载Excel模板</el-button>
            <el-button type="success" @click="exportFn">导入Excel</el-button>
          </section>
        </div>
        <div class="float-index.table">
          <el-table
              ref="multipleTable"
              :data="tableData"
              :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
              class="table"
              style="width: 100%"
              @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
                :index="indexFn"
                align="center"
                label="序号"
                type="index"
                width="150"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务次数"
                prop="serviceNum"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务机构"
                prop="serviceOrgan"
            ></el-table-column>
            <el-table-column
                align="center"
                label="地区"
                prop="address"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务成果"
                prop="serviceGain"
            ></el-table-column>
            <el-table-column
                :formatter="formatter"
                align="center"
                label="服务类型"
                prop="serviceType"
            ></el-table-column>
            <el-table-column
                align="center"
                label="兑现金额（万元）"
                prop="money"
            ></el-table-column>
            <!-- <el-table-column
              label="交易日期"
              align="center"
              prop="assign_date"
            ></el-table-column> -->
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.row)"
                >编辑
                </el-button
                >
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.row.id)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            :current-page.sync="currentPage"
            :page-size="page_size"
            :total="total"
            layout="total,prev, pager, next"
            style="text-align: left; margin: 20px 0"
            @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
        :close-on-click-modal="false"
        :title="tipTitle"
        :visible.sync="dialogFormVisible"
        width="30%"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item
            :label-width="formLabelWidth"
            label="使用企业"
            prop="name"
        >
          <el-input
              v-model="form.name"
              autocomplete="off"
              placeholder="请输入使用企业"
          ></el-input>
        </el-form-item>
        <el-form-item
            :label-width="formLabelWidth"
            label="服务次数"
            prop="serviceNum"
        >
          <el-input
              v-model="form.serviceNum"
              autocomplete="off"
              placeholder="请输入服务次数"
          ></el-input>
        </el-form-item>
        <el-form-item
            :label-width="formLabelWidth"
            label="服务机构"
            prop="serviceOrgan"
        >
          <el-input
              v-model="form.serviceOrgan"
              autocomplete="off"
              placeholder="请输入服务机构"
          ></el-input>
        </el-form-item>
        <el-form-item
            :label-width="formLabelWidth"
            label="地区"
            prop="address"
        >
          <el-select
              v-model="form.address"
              placeholder="请选择地区"
              style="width: 100%"
          >
            <el-option
                v-for="(item, index) in addressOption"
                :key="index"
                :label="item"
                :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            :label-width="formLabelWidth"
            label="服务类型"
            prop="serviceType"
        >
          <el-select
              v-model="form.serviceType"
              placeholder="请选择服务类型"
              style="width: 100%"
          >
            <el-option
                v-for="(item, index) in serviceTypes"
                :key="index"
                :label="item.label"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            :label-width="formLabelWidth"
            label="申请主体"
            prop="applyMain"
        >
          <el-select
              v-model="form.applyMain"
              placeholder="请选择服务类型"
              style="width: 100%"
          >
            <el-option v-for="(item,index) in applyMain" :key="index" :label="item.label"
                       :value="item.id"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item
            :label-width="formLabelWidth"
            label="服务成果"
            prop="serviceGain"
        >
          <el-input
              v-model="form.serviceGain"
              autocomplete="off"
              placeholder="请输入服务成果"
          ></el-input>
        </el-form-item>
        <!--  <el-form-item
          label="交易日期"
          :label-width="formLabelWidth"
          prop="assign_date"
        >
          <el-date-picker
            v-model="form.assign_date"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择交易日期"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item
            :label-width="formLabelWidth"
            label="兑现金额"
            prop="money"
        >
          <el-input
              v-model="form.money"
              autocomplete="off"
              placeholder="请输入兑现金额"
              type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import {DisabledDateFn1, ExportFn, FunDownload} from ".././../utils/tool";

export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      current_url: `${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon/page`,
      export_url: `${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon/export`,
      tipTitle: "新增",
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      total: 0,
      tableData: [],
      deleteIds: "",
      currentPage: 1,
      serviceTypes: [],
      applyMain: [{id: 1, label: "企业"}, {id: 2, label: "团队"}],
      serviceTypes_map: new Map(),
      page_size: 10,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      form: {
        serviceNum: "",
        serviceOrgan: "",
        type: "3",
        serviceGain: "",
        money: "",
        assign_date: "",
        serviceType: "",
        adress: '',
      },
      rules: {
        serviceNum: [
          {
            required: true,
            message: "请输入服务次数",
            trigger: "blur",
          },
        ],
        serviceOrgan: [
          {
            required: true,
            message: "请选择服务机构",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请选择地区",
            trigger: "change",
          },
        ],
        serviceType: [
          {
            required: true,
            message: "请选择服务类型",
            trigger: "change",
          },
        ],
        assign_date: [
          {
            required: true,
            message: "请选择交易日期",
            trigger: "change",
          },
        ],
        money: [
          {
            required: true,
            message: "请输入兑现金额",
            trigger: "blur",
          },
        ],
      },
      addressOption: ['兰州市', '白银市', '武威市', '金昌市', '张掖市', '定西市', '嘉峪关市', '酒泉市', '平凉市', '庆阳市', '天水市', '陇南市', '临夏回族自治州', '甘南藏族自治州'],
    };
  },
  created() {
    this.ResetForm({value: this.form});
    this.getData(this.current_url, {page: this.currentPage});
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn1(time);
    },
    //序号
    indexFn(index) {
      return (this.currentPage - 1) * this.page_size + index + 1;
    },
    // 导入

    async exportFn() {
      let res = await ExportFn(this.export_url, {type: 3});

      if (res.code === 0 && res.data.is_export) {
        await this.getData(this.current_url, {page: this.currentPage});
        this.$message.success(`数据导入成功${res.data.suc_num || 0}条`);
      } else {
        this.$message.warning(`数据导入失败${res.data.fail_num || 0}条`);
      }
    },

    //   下载
    downFn() {
      FunDownload(
          this.imgUrl + "lanzhoufile/创新券兑现.xlsx",
          "创新券兑现.xlsx"
      );
    },

    // 批量删除
    deleteAll() {
      this.handleDelete(this.deleteIds);
    },

    //   分页改变
    handleCurrentChange(e) {
      this.getData(this.current_url, {page: e});
    },
    // 列表数据回填
    formatter(row, column, cellValue, index) {
      switch (column.property) {
        case "serviceType": {
          let value = this.serviceTypes_map.get(cellValue);
          return value || "";
          break;
        }
        default: {
          break;
        }
      }
    },

    //   新增 & 编辑
    onSubmit() {
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let obj = JSON.stringify(this.form);
          obj = JSON.parse(obj);

          if (obj?.id) {
            this.http
                .post(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon/update`, obj)
                .then((res) => {
                  if (res.code === 0) {
                    this.getData(this.current_url, {page: this.currentPage});
                    this.dialogFormVisible = false;

                    this.$message.success("更新成功");
                  }
                })
                .catch((err) => {
                  this.is_submit = true;
                });
          } else {
            this.http
                .post(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon/create`, obj)
                .then((res) => {
                  if (res.code === 0) {
                    this.dialogFormVisible = false;

                    this.getData(this.current_url, {page: this.currentPage});
                    this.$message.success("创新发放券成功");
                  }
                })
                .catch((err) => {
                  console.error("捕获", err);
                  this.is_submit = true;
                });
          }
        } else {
          this.is_submit = true;
        }
      });
    },

    // 获取列表
    async getData(url, data) {
      data.type = 3
      data.isDel = 0
      const res = await this.http.post(url, data);
      if (res.code === 0) {
        this.tableData = res.data.data.map((el) => {
          el.money = Number(el.money).toFixed(2);
          return el;
        });
        res.data.serviceTypes = {1: "检验检测", 2: "委托开发", 3: "专利申请代理", 4: "技术转移"}
        // 生成下拉选择
        if (!this.serviceTypes.length) {
          this.serviceTypes = Object.entries(res.data.serviceTypes).map(
              (el) => {
                this.serviceTypes_map.set(Number(el[0]), el[1]);

                return {
                  id: Number(el[0]),
                  label: el[1],
                };
              }
          );
        }

        this.total = res.data.total;
      }
    },
    // 编辑
    handleEdit(item) {
      this.tipTitle = "编辑";

      this.form = item;
      this.is_submit = true;
      this.dialogFormVisible = true;
    },
    async handleDelete(item) {
      this.$confirm("此操作将批量删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.http.delete(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon/deleteAll?ids=${item}`)
            .then((res) => {
              if (res.code === 0) {
                this.getData(this.current_url, {page: this.currentPage});
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            })
      })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    // 新增

    addEvent() {
      this.tipTitle = "新增";

      this.form = this.ResetForm({type: true, name: "form"});

      this.dialogFormVisible = true;

      this.is_submit = true;
    },
    // 城市
    citySelected(e) {
      this.form.address = e;
    },
    // 城市
    selectionChange(selection) {
      this.deleteIds = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteIds = arr.join(",");
      }
    },
  },
};
</script>

<style lang="scss">
@include component(coupon-service) {
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: space-between;

    @include component(el-input) {
      width: 300px;
    }
  }

  @include part(searchBtn) {
    margin-left: 10px;
  }

  @include part(addBtn) {
    margin-right: 30px !important;
    background: #623aa2 !important;
    color: #fff;
    border: none;
  }

  @include part(table) {
    margin-top: 30px;
  }
  .distpicker-address-wrapper {
    label {
      &:nth-last-of-type(1) {
        display: none;
      }
    }
  }
}
</style>
